
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.498 2.94l.69-.676c.35-.349.363-.725.055-1.04l-.232-.232c-.308-.307-.684-.273-1.032.062l-.69.683 1.209 1.203zm-8.06 8.04l7.458-7.452L8.7 2.325 1.235 9.783l-.65 1.518c-.06.164.11.355.274.287l1.58-.608z","fill":"#108999"}})])
          )
        }
      }
    